// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.playlistsWrapper--IJydS {
  grid-column-start: 2;
  grid-column-end: 26;
  grid-row-start: 3;
  grid-row-end: 4;
}
.skeletonWrapper--g1Z5y {
  display: grid;
  grid-column-start: 2;
  grid-column-end: 26;
  grid-gap: 1.5rem;
}
.sharedWithYouOverlay--avk7v {
  font-size: 0.875rem;
  border-radius: 4px 4px 0 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  background-color: #0a855c;
  font-weight: 500;
  width: 100%;
  height: 40px;
}
.cardWrapperGrid--cpmOL {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-gap: 1rem 1.5rem;
  place-content: start;
  grid-row-start: 4;
  grid-row-end: 4;
  grid-column-start: 2;
  grid-column-end: 26;
}
.skeletonCard--QsGfQ {
  width: 100%;
  position: relative;
  min-height: 289px;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
  display: grid;
  grid-template-rows: minmax(min-content, max-content) auto auto;
}
.description--DEVD6 {
  margin-top: 0.5rem;
  min-width: 100%;
}
.emptyPlaylistWrapper--kX3MA {
  display: flex;
  justify-content: center;
  align-items: center;
  grid-row-start: 3;
  grid-row-end: 3;
  grid-column-start: 2;
  grid-column-end: 26;
}
.modeList--SxyPa {
  grid-column-start: 2;
  grid-column-end: 26;
}
.playlistNavigation--iv_99 {
  display: flex;
  flex-direction: row;
  min-width: 100%;
  font-size: 0.875rem;
  align-items: center;
  margin-bottom: 0.5rem;
}
.playlistNavigation--iv_99 svg {
  margin-left: 0.875rem;
  margin-right: 0.6875rem;
}
.cover--zrvVL {
  background-position: center;
  background-size: cover;
  aspect-ratio: 16/9;
  background-repeat: no-repeat;
  min-height: 100%;
  border-radius: 4px;
}
.cover--zrvVL button {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cover--zrvVL span {
  visibility: hidden;
  display: none;
}
.gridView--rdb7w .ant-list-items {
  display: grid;
  grid-column-start: 2;
  grid-column-end: 26;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-gap: 1.5rem;
}
.gridView--rdb7w .pagination--YP5jc {
  margin-top: 60px;
}
.playlistSubheader--ZBFdl {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  color: #495A7C;
  margin: 0 0.25rem;
  align-items: center;
  overflow: hidden;
}
.playlistTabs--XnVaX .tabNavBar--kS1Kt {
  border-bottom: 2px solid #CBD5E0;
}
.playlistTabs--XnVaX .tabHeader--N_kwq {
  color: #495A7C;
  padding: 1rem 1rem 0.5rem;
  margin-right: 1rem;
}
.playlistTabs--XnVaX .tabHeader--N_kwq:first-child {
  padding: 1rem 1rem 0.5rem 0;
}
.playlistTabs--XnVaX .tabHeader--N_kwq :hover {
  color: #1A202C;
}
.playlistTabs--XnVaX .tabHeader--N_kwq[data-state='active'] {
  color: #1A202C;
  position: relative;
}
.playlistTabs--XnVaX .tabHeader--N_kwq[data-state='active']:after {
  content: '';
  background-color: #00217D;
  position: absolute;
  height: 4px;
  bottom: -3px;
  width: 100%;
  left: 0;
  border-radius: 4px;
}
.playlistTabs--XnVaX .tabContent--QaUkQ {
  padding-top: 2rem;
}
.playlistAssetNote--onS6m {
  background-color: var(--blue-200);
  border-radius: 4px;
  margin-bottom: 0.5rem;
  padding: 1rem;
}
@media screen and (min-width: 320px) {
  .cardWrapperGrid--cpmOL {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .skeletonWrapper--g1Z5y {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .playlistHeaderContainer--Qw_Fu {
    flex-direction: column;
    align-items: flex-start;
  }
  .gridView--rdb7w .ant-list-items {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media screen and (min-width: 768px) {
  .cardWrapperGrid--cpmOL {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .skeletonWrapper--g1Z5y {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .playlistHeaderContainer--Qw_Fu {
    flex-direction: row;
    align-items: center;
  }
  .gridView--rdb7w .ant-list-items {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media screen and (min-width: 1148px) {
  .cardWrapperGrid--cpmOL {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .skeletonWrapper--g1Z5y {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .description--DEVD6 {
    padding-right: 244px;
  }
  .gridView--rdb7w .ant-list-items {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/playlists/style.module.less"],"names":[],"mappings":"AAGA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAFF;AAKA;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAHF;AAMA;EACE,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAJF;AAOA;EACE,aAAA;EACA,gDAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AALF;AAQA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,iDAAA;EACA,aAAA;EACA,8DAAA;AANF;AASA;EACE,kBAAA;EACA,eAAA;AAPF;AAUA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AARF;AAWA;EACE,oBAAA;EACA,mBAAA;AATF;AAYA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAVF;AAIA;EASI,qBAAA;EACA,uBAAA;AAVJ;AAcA;EACE,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AAZF;AAMA;EASI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAZJ;AADA;EAiBI,kBAAA;EACA,aAAA;AAbJ;AAiBA;EAEI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;AAhBJ;AAUA;EAUI,gBAAA;AAjBJ;AAqBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAnBF;AAsBA;EAEI,gCAAA;AArBJ;AAmBA;EAMI,cAAA;EACA,yBAAA;EACA,kBAAA;AAtBJ;AAwBI;EACE,2BAAA;AAtBN;AAWA;EAeM,cAAA;AAvBN;AAQA;EAoBI,cAAA;EACA,kBAAA;AAzBJ;AA2BI;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;AAzBN;AANA;EAoCI,iBAAA;AA3BJ;AAgCE;EAAA,iCAAA;EACA,kBAAA;EACA,qBAAA;EACA;AAHA;AAMF;EACE;IACE,gDAAA;EA9BF;EAiCA;IACE,gDAAA;EA/BF;EAkCA;IACE,sBAAA;IACA,uBAAA;EAhCF;EAmCA;IAEI,gDAAA;EAlCJ;AACF;AAsCA;EACE;IACE,gDAAA;EApCF;EAuCA;IACE,gDAAA;EArCF;EAwCA;IACE,mBAAA;IACA,mBAAA;EAtCF;EAyCA;IAEI,gDAAA;EAxCJ;AACF;AA4CA;EACE;IACE,gDAAA;EA1CF;EA6CA;IACE,gDAAA;EA3CF;EA8CA;IACE,oBAAA;EA5CF;EA+CA;IAEI,gDAAA;EA9CJ;AACF","sourcesContent":["@import '~@boclips-ui/styles/src/colors';\n@import '~@boclips-ui/styles/src/breakpoints';\n\n.playlistsWrapper {\n  grid-column-start: 2;\n  grid-column-end: 26;\n  grid-row-start: 3;\n  grid-row-end: 4;\n}\n\n.skeletonWrapper {\n  display: grid;\n  grid-column-start: 2;\n  grid-column-end: 26;\n  grid-gap: 1.5rem;\n}\n\n.sharedWithYouOverlay {\n  font-size: 0.875rem;\n  border-radius: 4px 4px 0 0;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: @white;\n  background-color: #0a855c;\n  font-weight: 500;\n  width: 100%;\n  height: 40px;\n}\n\n.cardWrapperGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-gap: 1rem 1.5rem;\n  place-content: start;\n  grid-row-start: 4;\n  grid-row-end: 4;\n  grid-column-start: 2;\n  grid-column-end: 26;\n}\n\n.skeletonCard {\n  width: 100%;\n  position: relative;\n  min-height: 289px;\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);\n  display: grid;\n  grid-template-rows: minmax(min-content, max-content) auto auto;\n}\n\n.description {\n  margin-top: 0.5rem;\n  min-width: 100%;\n}\n\n.emptyPlaylistWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  grid-row-start: 3;\n  grid-row-end: 3;\n  grid-column-start: 2;\n  grid-column-end: 26;\n}\n\n.modeList {\n  grid-column-start: 2;\n  grid-column-end: 26;\n}\n\n.playlistNavigation {\n  display: flex;\n  flex-direction: row;\n  min-width: 100%;\n  font-size: 0.875rem;\n  align-items: center;\n  margin-bottom: 0.5rem;\n\n  svg {\n    margin-left: 0.875rem;\n    margin-right: 0.6875rem;\n  }\n}\n\n.cover {\n  background-position: center;\n  background-size: cover;\n  aspect-ratio: 16/9;\n  background-repeat: no-repeat;\n  min-height: 100%;\n  border-radius: 4px;\n\n  button {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  span {\n    visibility: hidden;\n    display: none;\n  }\n}\n\n.gridView {\n  :global(.ant-list-items) {\n    display: grid;\n    grid-column-start: 2;\n    grid-column-end: 26;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    grid-gap: 1.5rem;\n  }\n\n  .pagination {\n    margin-top: 60px;\n  }\n}\n\n.playlistSubheader {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  color: @gray-700;\n  margin: 0 0.25rem;\n  align-items: center;\n  overflow: hidden;\n}\n\n.playlistTabs {\n  .tabNavBar {\n    border-bottom: 2px solid @gray-400;\n  }\n\n  .tabHeader {\n    color: @gray-700;\n    padding: 1rem 1rem 0.5rem;\n    margin-right: 1rem;\n\n    &:first-child {\n      padding: 1rem 1rem 0.5rem 0;\n    }\n\n    :hover {\n      color: @gray-900;\n    }\n  }\n\n  .tabHeader[data-state='active'] {\n    color: @gray-900;\n    position: relative;\n\n    &:after {\n      content: '';\n      background-color: @blue-800;\n      position: absolute;\n      height: 4px;\n      bottom: -3px;\n      width: 100%;\n      left: 0;\n      border-radius: 4px;\n    }\n  }\n\n  .tabContent {\n    padding-top: 2rem;\n  }\n}\n\n.playlistAssetNote {\n  @apply bg-blue-200;\n  border-radius: 4px;\n  margin-bottom: 0.5rem;\n  padding: 1rem;\n}\n\n@media screen and (min-width: @screen-sm) {\n  .cardWrapperGrid {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .skeletonWrapper {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .playlistHeaderContainer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .gridView {\n    :global(.ant-list-items) {\n      grid-template-columns: repeat(1, minmax(0, 1fr));\n    }\n  }\n}\n\n@media screen and (min-width: @screen-md) {\n  .cardWrapperGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .skeletonWrapper {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .playlistHeaderContainer {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .gridView {\n    :global(.ant-list-items) {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n}\n\n@media screen and (min-width: @screen-lg) {\n  .cardWrapperGrid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .skeletonWrapper {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .description {\n    padding-right: 244px;\n  }\n\n  .gridView {\n    :global(.ant-list-items) {\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"playlistsWrapper": `playlistsWrapper--IJydS`,
	"skeletonWrapper": `skeletonWrapper--g1Z5y`,
	"sharedWithYouOverlay": `sharedWithYouOverlay--avk7v`,
	"cardWrapperGrid": `cardWrapperGrid--cpmOL`,
	"skeletonCard": `skeletonCard--QsGfQ`,
	"description": `description--DEVD6`,
	"emptyPlaylistWrapper": `emptyPlaylistWrapper--kX3MA`,
	"modeList": `modeList--SxyPa`,
	"playlistNavigation": `playlistNavigation--iv_99`,
	"cover": `cover--zrvVL`,
	"gridView": `gridView--rdb7w`,
	"pagination": `pagination--YP5jc`,
	"playlistSubheader": `playlistSubheader--ZBFdl`,
	"playlistTabs": `playlistTabs--XnVaX`,
	"tabNavBar": `tabNavBar--kS1Kt`,
	"tabHeader": `tabHeader--N_kwq`,
	"tabContent": `tabContent--QaUkQ`,
	"playlistAssetNote": `playlistAssetNote--onS6m`,
	"playlistHeaderContainer": `playlistHeaderContainer--Qw_Fu`
};
export default ___CSS_LOADER_EXPORT___;
